module.exports = __webpack_public_path__ + "static/media/wateraid_2-min.1602e27e.png";